import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import verification from '@/store/verification.js'
import content from '@/store/content.js'
export default new Vuex.Store({
  state: {
    token: '',
    authenticated: false,
    user: {},
    email: '',
    bill: {}
  },
  mutations: {
    setToken(state, accessToken) {
      state.token = accessToken
      state.authenticated = true
    },
    setUser(state, accessUser) {
      state.user = accessUser
    },
    setEmail(state, accessEmail) {
      state.email = accessEmail
    },
    setBill(state, accessBill) {
      state.bill = accessBill
    },
  },
  actions: {
  },
  modules: {
    verification,
    content
  }
})
